var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBlogNav = function SvgBlogNav(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.49988,
    width: 16,
    height: 19,
    rx: 3,
    fill: "#78786D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.49988,
    width: 25,
    height: 23,
    rx: 3,
    fill: "#ECEAD9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4.49988,
    width: 10,
    height: 9,
    rx: 2,
    stroke: "#FFFFFA",
    strokeDasharray: "1 1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24.4999,
    width: 10,
    height: 9,
    rx: 2,
    stroke: "#FFFFFA",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.99988H4",
    stroke: "#FFFFFA",
    strokeDasharray: "1 1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12.4999,
    width: 10,
    height: 9,
    rx: 2,
    fill: "#B9B8AB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23.4999,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#B9B8AB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27.4999,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#B9B8AB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlogNav);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNSAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iNi40OTk4OCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE5IiByeD0iMyIgZmlsbD0iIzc4Nzg2RCIvPgo8cmVjdCB4PSI3IiB5PSI5LjQ5OTg4IiB3aWR0aD0iMjUiIGhlaWdodD0iMjMiIHJ4PSIzIiBmaWxsPSIjRUNFQUQ5Ii8+CjxyZWN0IHg9IjIyIiB5PSI0LjQ5OTg4IiB3aWR0aD0iMTAiIGhlaWdodD0iOSIgcng9IjIiIHN0cm9rZT0iI0ZGRkZGQSIgc3Ryb2tlLWRhc2hhcnJheT0iMSAxIi8+CjxyZWN0IHg9IjMiIHk9IjI0LjQ5OTkiIHdpZHRoPSIxMCIgaGVpZ2h0PSI5IiByeD0iMiIgc3Ryb2tlPSIjRkZGRkZBIiBzdHJva2UtZGFzaGFycmF5PSIxIDEiLz4KPHBhdGggZD0iTTE3LjUgNC45OTk4OEg0IiBzdHJva2U9IiNGRkZGRkEiIHN0cm9rZS1kYXNoYXJyYXk9IjEgMSIvPgo8cmVjdCB4PSIxMCIgeT0iMTIuNDk5OSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjkiIHJ4PSIyIiBmaWxsPSIjQjlCOEFCIi8+CjxyZWN0IHg9IjEwIiB5PSIyMy40OTk5IiB3aWR0aD0iMTkiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiNCOUI4QUIiLz4KPHJlY3QgeD0iMTAiIHk9IjI3LjQ5OTkiIHdpZHRoPSIxOSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iI0I5QjhBQiIvPgo8L3N2Zz4K";